import { themedUseStyletron } from '../../../theme/customTheme'
import { LabelLarge } from 'baseui/typography';
import { OperatorPanelWrapperFullSize } from '../../components/Layout'
import { ISensorDigital } from './types'
// icons
import { FormattedMessage } from 'react-intl';
import { Block } from 'baseui/block';
import { VscCircleLarge, VscPassFilled } from 'react-icons/vsc';
import { ObjectBooleanTimeline } from '../../../features/Charts/ObjectBooleanTimeline';
import { LastXDaysLabel } from './LastXDaysLabel';
import { getTimeRangeFromTimespan } from '../../../utils/timeUtils';

export const OperatorPanel = (props: ISensorDigital) => {
    const [, theme] = themedUseStyletron();
    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);
    
    return (
        <>
            <OperatorPanelWrapperFullSize
                objectId={props.id}
                resourceGroupId={props.resourceGroupId}
                statusContent={
                    <>
                        <Block display={'flex'} alignItems='center' flexDirection='row' gridGap={theme.sizing.scale400}>
                            {props.isOn &&
                                <>
                                    <VscPassFilled color={theme.appColors.aggregate.on} size={theme.sizing.scale800}></VscPassFilled>
                                    <LabelLarge><FormattedMessage id="Devices.ON" defaultMessage="ON" /></LabelLarge>
                                </>
                            }
                            {!props.isOn &&
                                <>
                                    <VscCircleLarge color={theme.appColors.aggregate.off} size={theme.sizing.scale800}></VscCircleLarge>
                                    <LabelLarge color={theme.appColors.aggregate.off}><FormattedMessage id="Devices.OFF" defaultMessage="OFF" /></LabelLarge>
                                </>
                            }

                        </Block>
                    </>
                }  >
            </OperatorPanelWrapperFullSize>
            <Block marginTop={theme.sizing.scale800}></Block>
            <LastXDaysLabel days={7}></LastXDaysLabel>
            <ObjectBooleanTimeline currentValue={props.isOn} onColor={theme.colors.positive} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isOn'}></ObjectBooleanTimeline>
        </>
    )
}
